<template>
  <div class="calendar-page">
    <div class="calendar-controls">
      <div class="calendar-controls-left">
        <button class="nav-btn" @click="prevMonth">
          &laquo; {{ prevMonthName }}
        </button>
      </div>
      <div class="calendar-controls-center">
        <span class="calendar-title">{{ monthYear }}</span>
      </div>
      <div class="calendar-controls-right">
        <button class="nav-btn" @click="nextMonth">
          {{ nextMonthName }} &raquo;
        </button>
      </div>
    </div>
    <FullCalendar
      ref="fullCalendar"
      :options="calendarOptions"
      class="calendar-table-wrapper"
    />
    <!-- 悬浮自定义弹窗 -->
    <div
      v-if="tooltip.show"
      class="custom-tooltip"
      :style="{ top: tooltip.top + 'px', left: tooltip.left + 'px' }"
      @mouseenter="handleTooltipMouseEnter"
      @mouseleave="handleTooltipMouseLeave"
    >
      <div class="custom-tooltip-arrow"></div>
      <div class="custom-tooltip-image" v-if="tooltip.img">
        <img :src="tooltip.img" />
      </div>
      <div class="custom-tooltip-title">{{ tooltip.title }}</div>
      <div class="custom-tooltip-date">{{ tooltip.date }}</div>
      <div v-if="tooltip.country" class="custom-tooltip-country">
        {{ tooltip.country }}
      </div>
      <div class="custom-tooltip-desc" v-html="tooltip.desc"></div>
    </div>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import request, { previewImg } from '../../utils/request'
export default {
  name: 'CalendarPage',
  components: { FullCalendar },
  data() {
    const today = new Date()
    return {
      current: new Date(today.getFullYear(), today.getMonth(), 1),
      events: [], // 初始化空数组
      calendarOptions: {
        plugins: [dayGridPlugin],
        initialView: 'dayGridMonth',
        initialDate: today,
        headerToolbar: false,
        firstDay: 1,
        fixedWeekCount: true,
        events: [], // 初始化为空数组
        dayCellDidMount(arg) {
          const dayNumber = arg.dayNumberText
          const cell = arg.el
          const dayDiv = document.createElement('div')
          dayDiv.className = 'cell-day'
          dayDiv.textContent = dayNumber
          cell.appendChild(dayDiv)
        },
        dayMaxEvents: true,
        height: 'auto',
        eventDisplay: 'block',
        eventTimeFormat: {
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false
        },
        dayHeaderFormat: { weekday: 'long' }
      },
      tooltip: {
        show: false,
        top: 0,
        left: 0,
        title: '',
        date: '',
        country: '',
        desc: '',
        img: ''
      }
    }
  },
  computed: {
    monthYear() {
      return this.current.toLocaleString('en-US', {
        month: 'long',
        year: 'numeric'
      })
    },
    prevMonthName() {
      const prev = new Date(
        this.current.getFullYear(),
        this.current.getMonth() - 1,
        1
      )
      return prev.toLocaleString('en-US', { month: 'long' })
    },
    nextMonthName() {
      const next = new Date(
        this.current.getFullYear(),
        this.current.getMonth() + 1,
        1
      )
      return next.toLocaleString('en-US', { month: 'long' })
    }
  },
  methods: {
    stripcountry(html) {
      if (!html) return '';
      return html.replace(/<[^>]*>/g, '');
    },
    getStoryData() {
      // 获取日历视图的第一个和最后一个日期
      const calendarApi = this.$refs.fullCalendar.getApi()
      const view = calendarApi.view
      const firstDay = view.activeStart
      const lastDay = view.activeEnd

      // 格式化日期为 YYYY-MM-DD 格式
      const formatDate = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }

      request({
        url: '/article/listPage',
        params: {},
        data: {
          isValid: '1',
          articleType: 'swrl',
          publishTimes: [formatDate(firstDay), formatDate(lastDay)]
        },
        method: 'post'
      }).then(res => {
        // 将接口返回的数据转换为日历事件格式
        this.events = res.rows.map(item => {
          let decodedContent = '';
          if (item.content) {
            try {
              decodedContent = decodeURIComponent(item.content);
            } catch (e) {
              // 如果解码失败，直接使用原始内容
              decodedContent = item.content;
              console.warn('Content decoding failed:', e);
            }
          }

          return {
            title: item.title,
            start: item.publishTime,
            display: 'block',
            extendedProps: {
              tooltip: decodedContent,
              country: item.tags,
              img: item.listImage
            }
          };
        })

        // 更新日历的事件数据
        const calendarApi = this.$refs.fullCalendar.getApi()
        calendarApi.removeAllEvents()
        calendarApi.addEventSource(this.events)
      })
    },
    prevMonth() {
      this.$refs.fullCalendar.getApi().prev()
      this.updateCurrent()
      this.getStoryData() // 添加这行来重新获取数据
    },
    nextMonth() {
      this.$refs.fullCalendar.getApi().next()
      this.updateCurrent()
      this.getStoryData() // 添加这行来重新获取数据
    },
    updateCurrent() {
      const calendarApi = this.$refs.fullCalendar.getApi()
      const date = calendarApi.getDate()
      this.current = new Date(date.getFullYear(), date.getMonth(), 1)
    },
    // 悬浮显示
    showTooltip(info) {
      const date = new Date(info.event.start)
      const dateStr = date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })

      // 计算悬浮窗位置，确保在视窗内
      const tooltipWidth = 420 // 最大宽度
      const viewportWidth = window.innerWidth
      let left = info.jsEvent.clientX

      // 确保提示框不会超出右边界
      if (left + tooltipWidth > viewportWidth) {
        left = viewportWidth - tooltipWidth - 20
      }

      if (this.tooltip.hideTimeout) {
        clearTimeout(this.tooltip.hideTimeout)
      }

      this.tooltip = {
        show: true,
        isHovering: false,
        hideTimeout: null,
        top: info.jsEvent.pageY + 10,
        left: left,
        title: info.event.title,
        date: dateStr,
        country: info.event.extendedProps.country || '',
        img: info.event.extendedProps.img || '',
        desc: info.event.extendedProps.tooltip || ''
      }
    },

    handleTooltipMouseEnter() {
      if (this.tooltip.hideTimeout) {
        clearTimeout(this.tooltip.hideTimeout)
      }
      this.tooltip.isHovering = true
    },

    handleTooltipMouseLeave() {
      this.tooltip.isHovering = false
      setTimeout(() => {
        this.tooltip.show = false
      }, 100)
    },

    hideTooltip() {
      this.tooltip.hideTimeout = setTimeout(() => {
        if (!this.tooltip.isHovering) {
          this.tooltip.show = false
        }
      }, 300)  // 增加延迟时间到 300ms
    }
  },
  mounted() {

    // 绑定悬浮事件
    this.$nextTick(() => {
      const calendarApi = this.$refs.fullCalendar.getApi()
      calendarApi.on('eventMouseEnter', this.showTooltip)
      calendarApi.on('eventMouseLeave', this.hideTooltip)
    })
    this.getStoryData()
  },
  beforeDestroy() {
    if (this.tooltip.hideTimeout) {
      clearTimeout(this.tooltip.hideTimeout)
    }
    this.tooltip.show = false
  }
}
</script>

<style>
/* 保留 index.vue 的日历整体样式 */
.calendar-page {
  font-family: 'Segoe UI', Arial, sans-serif;
  background: #fff;
  min-height: 100%;
}
.calendar-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 0 12px 0;
  gap: 24px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.calendar-controls-left,
.calendar-controls-center,
.calendar-controls-right {
  flex: 1;
  display: flex;
  align-items: center;
}
.calendar-controls-center {
  justify-content: center;
}
.calendar-controls-left {
  justify-content: flex-start;
}
.calendar-controls-right {
  justify-content: flex-end;
}
.calendar-title {
  font-size: 1.3rem;
  font-weight: bold;
  color: #f26522;
  background: #fff;
  border-radius: 8px;
  padding: 6px 32px;
}
.nav-btn {
  background: #fff;
  border: 1px solid #000;
  color: #f26522;
  border-radius: 8px;
  padding: 6px 16px;
  font-weight: bold;
  cursor: pointer;
}
.calendar-table-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  border: none !important;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding-bottom: 32px;
}
.fc {
  background: #fff;
}
.fc-daygrid-day {
  border: 1px solid #000;
  height: 160px;
  vertical-align: top;
  padding: 0;
  position: relative;
}
.fc .fc-daygrid-day.fc-day-other .cell-day {
  background-color: #f9f9f9 !important;
  color: #999;
}
.fc-daygrid-day-number {
  display: none;
}
.cell-day {
  font-weight: bold;
  margin-bottom: 8px;
  background: #3b3e40;
  color: #fff; /* 修改文字颜色为深灰色 */
  line-height: 30px;
  padding-left: 10px;
  text-align: left;
  height: 30px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.fc-daygrid-day-events {
  padding-top: 40px !important;
  position: relative;
  z-index: 2;
}
.fc-event {
  background: none !important;
  border: none !important;
  color: #007bff !important;
  font-weight: normal;
  font-size: 1rem;
  text-align: left;
  margin-left: 10px;
  margin-top: 4px !important;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  z-index: 2;
  padding: 4px 8px !important;
  border-radius: 0 !important;
  background-color: transparent !important;
  border-left: none !important;
}

.fc-event-time {
  color: #333 !important; /* 添加事件时间的颜色 */
  display: none;
  font-weight: 500;
  margin-right: 10px;
}
.fc-day-past .fc-event {
  color: #999 !important;
}
.fc-daygrid-day-events > .fc-daygrid-event-harness {
  border-bottom: 1px solid #e0e0e0;
  margin-top: 0 !important;
}

/* 最后一个事件容器不显示边框 */
.fc-daygrid-day-events > .fc-daygrid-event-harness:nth-last-child(2) {
  border-bottom: none !important;
  margin-bottom: 0 !important;
}
.fc-daygrid-day-bottom {
  display: none;
}
.fc-event-title {
  font-weight: 500 !important;
  color: #1d7d99 !important;
  width: 100%;
  font-size: 0.9rem;
  padding-bottom: 8px;
  margin-bottom: 8px;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal !important;
}
.fc .fc-daygrid-day.fc-day-other .fc-event-title {
  color: rgba(17, 75, 125, 0.45) !important;
}
/* 最后一个事件不显示下划线 */
.fc-daygrid-event:last-child .fc-event-title {
  /* border-bottom: none !important; */
  /* margin-bottom: 0;
  padding-bottom: 0; */
}

.fc-daygrid-event {
  margin-top: 4px !important;
  background: transparent !important;
  border: none !important;
}
.fc-daygrid-event-dot {
  display: none !important;
}
.fc-daygrid-day.fc-day-other {
  background: #f9f9f9;
}
.fc-scrollgrid,
.fc-scrollgrid table {
  border-collapse: collapse !important;
}
.fc-col-header-cell {
  background: #fff;
  color: #222;
  font-weight: bold;
  text-align: center;
  font-size: 1.1rem;
  padding: 18px 0;
  letter-spacing: 0.5px;
  font-family: 'Segoe UI', Arial, sans-serif;
  height: 45px;
  line-height: 45px;
  box-sizing: border-box;
}
.fc-col-header-cell:first-child {
  border-left: 2.5px solid #000 !important;
}
.fc-col-header-cell:last-child {
  border-right: 2.5px solid #000 !important;
}
.fc-daygrid-body {
  width: 100% !important;
}
.fc-daygrid-day-frame {
  padding: 0 !important;
}
.fc-daygrid-day-top {
  display: none !important;
}

/* 保留2.vue的弹窗样式 */
.custom-tooltip {
  position: absolute;
  min-width: 340px;
  max-width: 420px;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16),
    0 1.5px 6px rgba(242, 101, 34, 0.08);
  padding: 36px 40px 28px 40px;
  z-index: 9999;
  left: 50%;
  top: 60px;
  transform: translateX(-50%);
  color: #22242a;
  font-family: 'Segoe UI', Arial, sans-serif;
  animation: fadeIn 0.18s;
  border: none;
  transition: box-shadow 0.2s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.custom-tooltip-arrow {
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-bottom: 14px solid #fff;
  filter: drop-shadow(0 -2px 6px rgba(0, 0, 0, 0.1));
}

.custom-tooltip-title {
  color: #f26522;
  font-size: 1.6rem;
  font-weight: bold;
  margin-bottom: 18px;
  line-height: 1.3;
  letter-spacing: 0.5px;
  word-break: break-word;
}

.custom-tooltip-date {
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 12px;
  color: #22242a;
  /* border-bottom: 2px solid #f26522; */
  display: inline-block;
  padding-bottom: 2px;
  letter-spacing: 0.2px;
}

.custom-tooltip-country {
  display: block;
  border: 2px solid #f26522;
  color: #000;
  border-radius: 18px;
  padding: 4px 22px;
  font-size: 1.05rem;
  margin-bottom: 14px;
  margin-top: 8px;
  background: #fff;
  font-weight: 500;
  letter-spacing: 0.2px;
}

.custom-tooltip-desc {
  color: #666;
  font-size: 1rem;
  margin-top: 16px;
  line-height: 1.85;
  letter-spacing: 0.1px;
  word-break: break-word;
}
.custom-tooltip-image {
  width: 100%;
  margin-bottom: 20px;
  border-radius: 8px;
  overflow: hidden;
}

.custom-tooltip-image img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 8px;
  object-fit: cover;
}
</style>
